type BootstrapDropdownInstance = {
  hide: () => void;
};

type BootstrapDropdownStatic = {
  getOrCreateInstance: (element: Element) => BootstrapDropdownInstance;
};

declare global {
  interface Window {
    bootstrap?: {
      Dropdown?: BootstrapDropdownStatic;
    };
    __tableActionSingleOpenDropdownInit?: boolean;
  }
}

const DROPDOWN_TOGGLE_SELECTOR = '[data-bs-toggle="dropdown"]';
const OPEN_DROPDOWN_MENU_SELECTOR = ".dropdown-menu.show";
const ACTION_MENU_ICON_SELECTOR = ".ti-dots-vertical, .fa-ellipsis-v";

const isRowActionDropdownToggle = (toggle: HTMLElement) => {
  const dropdownRoot = toggle.closest(".dropdown");

  if (!dropdownRoot) {
    return false;
  }

  if (dropdownRoot.classList.contains("table-action")) {
    return true;
  }

  if (toggle.classList.contains("action-icon")) {
    return true;
  }

  if (toggle.querySelector(ACTION_MENU_ICON_SELECTOR)) {
    return true;
  }

  return false;
};

const hideDropdownByToggle = (toggle: HTMLElement) => {
  const dropdownApi = window.bootstrap?.Dropdown;

  if (dropdownApi?.getOrCreateInstance) {
    dropdownApi.getOrCreateInstance(toggle).hide();
    return;
  }

  toggle.setAttribute("aria-expanded", "false");
  const dropdownRoot = toggle.closest(".dropdown");
  dropdownRoot?.classList.remove("show");

  const menu = dropdownRoot?.querySelector<HTMLElement>(".dropdown-menu.show");
  menu?.classList.remove("show");
};

const closeOtherTableActionDropdowns = (activeToggle: HTMLElement) => {
  const openMenus = Array.from(
    document.querySelectorAll<HTMLElement>(OPEN_DROPDOWN_MENU_SELECTOR)
  );

  openMenus.forEach((menu) => {
    const ownerToggle = menu
      .closest(".dropdown")
      ?.querySelector<HTMLElement>(DROPDOWN_TOGGLE_SELECTOR);

    if (ownerToggle && ownerToggle !== activeToggle) {
      hideDropdownByToggle(ownerToggle);
      return;
    }

    if (!ownerToggle) {
      menu.classList.remove("show");
    }
  });
};

export const initializeTableActionSingleOpenDropdown = () => {
  if (typeof document === "undefined") {
    return;
  }

  if (window.__tableActionSingleOpenDropdownInit) {
    return;
  }

  const onDocumentClickCapture = (event: MouseEvent) => {
    const target = event.target as Element | null;
    if (!target) {
      return;
    }

    const toggle = target.closest(DROPDOWN_TOGGLE_SELECTOR) as
      | HTMLElement
      | null;

    if (!toggle || !isRowActionDropdownToggle(toggle)) {
      return;
    }

    closeOtherTableActionDropdowns(toggle);
  };

  document.addEventListener("click", onDocumentClickCapture, true);
  window.__tableActionSingleOpenDropdownInit = true;
};
